(() => {
  const init = (root) => {
    if (!root || root.dataset.siecleCartReady === 'true') return;
    root.dataset.siecleCartReady = 'true';
    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-siecle-qty-step]');
      if (!button || !root.contains(button)) return;
      const control = button.closest('.siecle-cart__quantity');
      const input = control && control.querySelector('[data-siecle-cart-qty]');
      const form = button.closest('form');
      if (!input || !form) return;
      const current = Math.max(0, Number.parseInt(input.value, 10) || 0);
      const delta = Number(button.dataset.siecleQtyStep) || 0;
      input.value = String(Math.max(0, current + delta));
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  };
  const start = () => document.querySelectorAll('.siecle-cart').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();